import Vue from 'vue'

import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import {
  ClosePopup,
  Dialog,
  Notify,
  QBadge,
  QBanner,
  QBar,
  QBtn,
  QCard,
  QCardActions,
  QCardSection,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QCheckbox,
  QChip,
  QCircularProgress,
  QDate,
  QDialog,
  QDrawer,
  QExpansionItem,
  QField,
  QForm,
  QHeader,
  QIcon,
  QImg,
  QInfiniteScroll,
  QInnerLoading,
  QInput,
  QItem,
  QItemLabel,
  QItemSection,
  QLayout,
  QLinearProgress,
  QList,
  QMenu,
  QOptionGroup,
  QPage,
  QPageContainer,
  QPopupProxy,
  QRadio,
  QRouteTab,
  QScrollArea,
  QSelect,
  QSeparator,
  QSpace,
  QSpinner,
  QSpinnerDots,
  QTab,
  QTable,
  QTabPanel,
  QTabPanels,
  QTabs,
  QTd,
  QTh,
  QTimeline,
  QTimelineEntry,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  QTr,
  Quasar,
  Ripple,
} from 'quasar'

Vue.use(Quasar, {
  components: {
    QLayout,
    QCircularProgress,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QImg,
    QPopupProxy,
    QToolbar,
    QToolbarTitle,
    QExpansionItem,
    QBtn,
    QIcon,
    QRadio,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QTable,
    QTh,
    QTr,
    QTd,
    QForm,
    QLinearProgress,
    QInput,
    QField,
    QCheckbox,
    QScrollArea,
    QCard,
    QDialog,
    QSeparator,
    QCardSection,
    QCardActions,
    QSelect,
    QTooltip,
    QOptionGroup,
    QTab,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QTabs,
    QRouteTab,
    QTabPanels,
    QTabPanel,
    QSpace,
    QTimeline,
    QBar,
    QTimelineEntry,
    QInfiniteScroll,
    QSpinnerDots,
    QInnerLoading,
    QDate,
    QSpinner,
    QBadge,
    QMenu,
    QBanner,
    QChip,
  },
  directives: { Ripple, ClosePopup },
  plugins: {
    Notify, Dialog,
  },
  config: {
    notify: { /* Notify defaults */ },
  },
})
